import React from "react";
import { Route, withRouter, Redirect } from "react-router-dom";
import { inject, observer } from "mobx-react";
import { compose } from "recompose";
import { graphql } from "@apollo/client/react/hoc";
import { PROVIDER_CARD_INFO_QUERY, TAGS_ONE_QUERY } from "Services/queries";
import withDefaultParams, { generateUrl } from "Services/withDefaultParams";
import configRouters from "Configs/routes";
import WithSeoText from "Layouts/WithSeoText";
import ProviderHeaderWrapperContainer from "Containers/ProviderHeaderWrapperContainer";
import { LoadingV2 } from "ComponentsUI/Loading";
import { Redirect404 } from "ComponentsUI/Redirects";

const Wrapper = (props) => {
	if (
		props?.providerForCard?.loading ||
		(props.rest.seoPath === "ProviderRatesTags" && props.tagsOneQuery.loading)
	) {
		return <LoadingV2 show={true} />;
	}
	if (!props?.providerForCard.provider) {
		let location = {
			pathname: generateUrl(configRouters.Providers.route, props.match.params),
			state: {
				isRedirect: true,
			},
		};
		return <Redirect to={location} />;
	}

	let {
		ApplicationModel: { routesModel, text },
		matchProps,
		rest,
		mainComponent: MainComponent,
		seoData,
		route,
	} = props;

	let tagsOne = props?.tagsOneQuery?.tagsOne || null;
	if (props.rest.seoPath === "ProviderRatesTags" && !tagsOne) {
		return <Redirect404 message404={"У провайдера выбран не правильный тег"} />;
	}

	routesModel.setTag(tagsOne);

	let page = props?.match?.params?.page;
	const providerForCard = props.providerForCard?.provider;
	let seoText = props?.seoData?.main_text;
	let hideTitle;
	let hideText;
	if (props.rest && props.rest.seoPath === "ProviderRates") {
		//Убрать тайтл в сео тексте, если тарифов нет
		if (!props.providerForCard?.provider.info?.cnt_tariffs) {
			hideTitle = true;
		}
	}

	// Не показывать сеотекст, если нет тарифов у провайдера
	if (
		props.rest &&
		props.rest.seoPath === "ProviderDetails" &&
		!props.providerForCard?.provider?.info?.cnt_tariffs
	) {
		hideText = true;
	}

	// Убрать сеоТекст со страницы пагинации
	if (page && page != 1) {
		hideText = true;
	}

	return (
		<>
			<ProviderHeaderWrapperContainer
				seoData={props.seoData}
				notH1={rest.notH1}
				defaultHeader={rest.defaultHeader}
				providerForCard={props.providerForCard}
			/>
			<WithSeoText
				seoData={seoData}
				seoText={seoText}
				text={text}
				hideTitle={hideTitle}
				hideText={hideText}
			>
				<MainComponent
					{...matchProps}
					route={route}
					seoData={props.seoData}
					providerForCard={providerForCard}
				/>
			</WithSeoText>
		</>
	);
};

const WrapperWithData = withRouter(
	withDefaultParams(
		compose(
			graphql(TAGS_ONE_QUERY, {
				skip: (props) => {
					return !props.match.params?.tagCode;
				},
				options: (props) => {
					let filter = [`translit=${props.match.params.tagCode}`, "type=provider"];
					return {
						variables: {
							filter: filter.join("&"),
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data) {
						return {
							...ownProps,
							tagsOneQuery: data,
						};
					}
				},
			}),
			graphql(PROVIDER_CARD_INFO_QUERY, {
				options: (props) => {
					let filter = `region.url=${props.match.params.regionUrl}`;
					filter += `&url_name=${props.match.params.providerName}`;
					filter += "&mobile_operator=0";

					let partFilter = `region.url=${props.match.params.regionUrl}&provider.url_name=${props.match.params.providerName}`;
					let filterNews = partFilter + "&is_action=0";
					let filterActions = partFilter + "&is_action=1";

					return {
						variables: {
							filter: filter,
							filterNews: filterNews,
							filterActions: filterActions,
						},
					};
				},
				props: ({ ownProps, data }) => {
					if (data) {
						return {
							...ownProps,
							providerForCard: data,
						};
					}
					return null;
				},
			})
		)(Wrapper)
	)
);

const ProviderLayout = ({ component: Component, seoData, ApplicationModel, ...rest }) => {
	return (
		<Route
			{...rest}
			render={() => {
				return (
					<WrapperWithData
						seoData={seoData}
						route={rest.route}
						rest={rest}
						mainComponent={Component}
						ApplicationModel={ApplicationModel}
					/>
				);
			}}
		/>
	);
};

export default inject("ApplicationModel")(observer(ProviderLayout));
